import LoadingPageLogo from "../assets/images/Fabicon.svg";

function PageLoadingSpinner() {
  return <img className="page-loading-image" src={LoadingPageLogo} alt="Loading..." />;
}

export default PageLoadingSpinner;
